import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.data.sources');
import { OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom, Observable } from 'rxjs';
import { Service } from "src/libs/portal/season/service";
import { DashboardSummaryService, DashboardSummaryState } from 'src/app/dashboard-summary.service';
import { AnalysisStatus, RegionNode, RegionSelectionService } from 'src/app/region-selection.service';

@Component({
    selector: 'wiz-page-data-sources',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.data.sources/view.scss */
:host {
  display: block;
  min-height: 100%;
  background: #f4f6f8;
}

table {
  border-collapse: separate;
  border-spacing: 0;
}

.status-card {
  min-width: 0;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  background: #fff;
  padding: 16px 18px;
}

.status-card p {
  font-size: 11px;
  font-weight: 800;
}

.status-card strong {
  display: block;
  margin-top: 7px;
  font-size: 22px;
}

.status-card--ready {
  border-top: 3px solid #2f8064;
  color: #176348;
}

.status-card--pending {
  border-top: 3px solid #bc7717;
  color: #8a5511;
}

.status-card--unavailable {
  border-top: 3px solid #8b96a3;
  color: #55616e;
}

.status-card--verified {
  border-top: 3px solid #2b5d87;
  color: #244f76;
}

dl div {
  display: grid;
  grid-template-columns: 92px minmax(0, 1fr);
  gap: 10px;
  border-bottom: 1px solid #f1f5f9;
  padding-bottom: 9px;
}

dt {
  color: #64748b;
  font-weight: 800;
}

dd {
  color: #0f172a;
  font-weight: 700;
}`],
})
export class PageDataSourcesComponent implements OnInit {
    public readonly summaryState$: Observable<DashboardSummaryState>;
    public metropolitanRegions: RegionNode[] = [];
    public referenceYearCatalog: any = null;
    public loadError: string = '';

    constructor(@Inject( DashboardSummaryService)         public dashboardSummary: DashboardSummaryService,@Inject( RegionSelectionService)         public regionSelection: RegionSelectionService,@Inject( Service)         public service: Service,@Inject( HttpClient)         private http: HttpClient,    ) {
        this.summaryState$ = this.dashboardSummary.state$;
    }

    public async ngOnInit() {
        await this.service.init();
        await this.load();
    }

    public async load(force = false) {
        this.loadError = '';
        try {
            await Promise.all([
                this.regionSelection.loadTree(),
                this.dashboardSummary.load(force),
                this.loadReferenceYears(force),
            ]);
            this.metropolitanRegions = this.regionSelection.tree?.regions || [];
        } catch (error) {
            this.loadError = '지역별 데이터 확보 상태를 불러오지 못했습니다. 다시 시도해 주세요.';
        } finally {
            await this.service.render();
        }
    }

    private async loadReferenceYears(force = false) {
        if (this.referenceYearCatalog && !force) return;
        const response: any = await firstValueFrom(
            this.http.get('/api/reference-years', { headers: { Accept: 'application/json' } })
        );
        this.referenceYearCatalog = response?.data?.years ? response.data : response;
        if (!Array.isArray(this.referenceYearCatalog?.years)) {
            throw new Error('기준연도 카탈로그 응답이 올바르지 않습니다.');
        }
    }

    public completenessLabel(status: string): string {
        return {
            COMPLETE: '완결 검증',
            PARTIAL: '부분 최신 데이터',
            UNAVAILABLE: '공식 원자료 미제공',
        }[status] || '확인 필요';
    }

    public async retry() {
        await this.load(true);
    }

    public statusCount(region: RegionNode, status: AnalysisStatus): number {
        return [region, ...(region.children || [])]
            .filter(item => item.analysis_status === status).length;
    }

    public formatCount(value: number | null | undefined): string {
        if (value === null || value === undefined) return '확인 필요';
        return Number(value).toLocaleString('ko-KR');
    }

    public formatUpdatedAt(value: string | null | undefined): string {
        if (!value) return '확인 필요';
        return new Intl.DateTimeFormat('ko-KR', {
            year: 'numeric', month: '2-digit', day: '2-digit',
            hour: '2-digit', minute: '2-digit', hour12: false,
        }).format(new Date(value));
    }

    public sourceName(tableId: string): string {
        const names: Record<string, string> = {
            DT_118N_SAUPN72: '전국·시도 사업체노동실태현황',
            DT_118N_SAUPN75: '특·광역시 하위 시군구 사업체노동실태현황',
            DT_118N_SAUPN78: '도 하위 시군구 사업체노동실태현황',
        };
        return names[tableId] || 'KOSIS 공식 통계표';
    }
}

export default PageDataSourcesComponent;